import InsightsPanel from '../../../components/InsightsPanel';
import { useBotWorkspace } from '../../../hooks/useBotWorkspace';

export default function InsightsRoute() {
  const { bot } = useBotWorkspace();
  if (!bot) return null;
  return <InsightsPanel bot={bot} />;
}
